import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";

import moment from "moment";
import { LimiteExposicao } from 'src/app/model/limite-exposicao.model';
import { LimiteExposicaoService } from '../limite-exposicao.service';


@Component({
    selector: 'app-limite-exposicao-listagem',
    templateUrl: './limite-exposicao-listagem.component.html',
    styleUrls: ['./limite-exposicao-listagem.component.scss'],
    standalone: false
})
export class LimiteExposicaoListagemComponent implements OnInit {

  @Input() agenteFinanceiro: AgenteFinanceiro;
  @Input() limites: LimiteExposicao[];
  @Input() msgSemResultado: boolean = false;
  @Input() dataHoraResultado: string;
  @Input() ehFGBS: boolean;
  @Output() public exportarLista: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  btnExportarLista() {
    this.exportarLista.emit(null);
  }

  temMensagem(limite: LimiteExposicao) {
    return limite.mensagem != null;
  }

  get tipValorDisponivel() {
    if (this.ehFGBS) {
      return "O valor disponível para contratação será o menor valor entre o limite de exposição do Agente Financeiro e o limite de contratação do FG BNDES-SEBRAE";
    }
    
    return "";
  }
}
